/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";
import { ecommerceapiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { showStatus, encodeValue, removeItem, showLoader, hideLoader, clientID, showAlert, checkingPermisson, showRecords, showSortingNew } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";

import "react-tooltip/dist/react-tooltip.css";
import AdminCateringOrderDetail from "./AdminCateringOrderDetail";
const Parser = require("html-react-parser");
var module = "catering";
var moduleName = "Orders";

class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    const locState = this.props.location?.state;
    const pathname = this.props.location?.pathname || "";
    this.state = {
      companyID: companyID,
      path: pathname,
      totalRecords: 0,
      totalPage: 0,
      currentPage: locState?.currentPage || 1,
      listdata: [],
      loading: true,
      name: locState?.name || "",
      status: locState?.status || "",
      storeID: locState?.storeID || "",
      subcategoryID: locState?.subcategoryID || "",
      specialPorduct: locState?.specialPorduct || "",
      outletList: [],
      errorFile: false,
      errorComobFile: false,
      allowOutlet: cookie.load("clientAllowOutlet") ?? "",
      exportUrl: "",
      selectedItem: [],
      sortKey: "",
      sortValue: "",
      productSequenceList: [],
      checkall: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(this.state.currentPage);
    this.loadOutlet();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState(
        {
          listdata: nextProps.listdata,
          loading: false,
          totalRecords: nextProps.totalRecords,
          totalPage: nextProps.totalPages,
        },
        () => {
          const isAllAvailable = this.state.listdata.every((item) => this.state.selectedItem.includes(item._id));
          this.setState({ checkall: isAllAvailable });
        },
      );
    }
    if (this.props.location?.state !== nextProps.location?.state) {
      this.setState(
        {
          name: nextProps.location?.state?.name || "",
          status: nextProps.location?.state?.status || "",
          storeID: nextProps.location?.state?.storeID || "",
          categoryID: nextProps.location?.state?.categoryID || "",
          subcategoryID: nextProps.location?.state?.subcategoryID || "",
          specialPorduct: nextProps.location?.state?.specialPorduct || "",
          currentPage: nextProps.location?.state?.currentPage || 1,
        },
        () => {
          this.loadList(this.state.currentPage);
        },
      );
    }
  }
  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
 

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
          checkall: false,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "sort") {
      const valueSplit = value.split("|");
      this.setState({ sortKey: valueSplit[0], sortValue: valueSplit[1] }, () => {
        this.loadList(this.state.currentPage);
      });
    }
  };
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, "client", this.sateValChange, this.state.currentPage, "ecom");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value }, () => {
    });
  }

  searchList() {
    this.setState({ loading: true, currentPage:1 }, () => {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addCondi = "";
    var params = {
      params: `limit=${this.state.pageLimit?.value?? 10}&offset=${offset}${addCondi}&orderType=${this.state.orderType}`,
      url: ecommerceapiUrl + module + "/orderlist",
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    const locStates = this.props.location?.state || "";
    if (locStates) {
      this.props.navigate("/clientpanel/ecom-products");
    } else {
      this.setState(
        {
          loading: true,
          name: "",
          storeID: "",
          categoryID: "",
          subcategoryID: "",
          specialPorduct: "",
          status: "",
          currentPage:1,
        },
        () => {
          this.loadList(1);
        },
      );
    }
  }
  importProduct() {
    $("#productmodal").modal("toggle");
  }

  showProductType(productType) {
    let result = "";
    if (productType === 1) {
      result = "Simple";
    } else if (productType === 2) {
      result = "Combo";
    } else if (productType === 3) {
      result = "Voucher";
    }
    return result;
  }
  selectItem(productID) {
    let selectedItem = this.state.selectedItem;
    if (selectedItem.indexOf(productID) >= 0) {
      selectedItem.splice(selectedItem.indexOf(productID), 1);
    } else {
      selectedItem.push(productID);
    }
    this.setState({ selectedItem });
  }

  handleChangeCheckAll() {
    let ids = this.state.listdata.map((item) => item._id);
    const checkall_ = this.state.checkall;
    if (checkall_) {
      ids = [];
    }

    this.setState({ checkall: !this.state.checkall, selectedItem: ids });
  }

  editItem(editID, e) {
    const details = {
      name: this.state.name,
      status: this.state.status,
      storeID: this.state.storeID,
      categoryID: this.state.categoryID,
      subcategoryID: this.state.subcategoryID,
      currentPage: this.state.currentPage,
    };
    e.preventDefault();
    this.props.navigate(`${this.state.path}/edit/${editID}`, {
      state: details,
    });
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar catering-order">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catering-orders"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card">               
                  <AdminCateringOrderDetail orders={this.state.listdata} loading={this.state.loading} />
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
